import { sortString, sortNumber, toSearchableString } from 'app/utils';
import _ from 'lodash';
import pullAllWith from 'lodash/pullAllWith';

const TEMPLATE_NAME = 'PROFESSIONALS_VISITS';

const sort = function (a, b) {
  let result = sortNumber(a.status, b.status);
  if (result !== 0) {
    return result;
  }
  const aName = a.name || null;
  const bName = b.name || null;
  result = sortString(aName, bName);
  if (result !== 0) {
    return result;
  }
  return sortString(a.key, b.key);
};

const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

const filterData = (data, term) => {
  const result = data.filter(visit => {
    if (visit.professional) {
      const professionalName = visit.professional.name
        ? filterByTerm(visit.professional.name, term)
        : false;
      const patientName = visit.patient.name ? filterByTerm(visit.patient.name, term) : false;

      return professionalName || patientName;
    }

    const patientName = visit.patient.name ? filterByTerm(visit.patient.name, term) : false;

    return patientName;
  });
  if (sort) {
    result.sort(sort);
  }
  return result;
};

const initialState = () => ({
  loading: false,
  loadedData: [],
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    // case `${TEMPLATE_NAME}_PENDING`: {
    //   return {
    //     ...state,
    //     loading: true
    //   };
    // }
    // case `${TEMPLATE_NAME}_REJECTED`: {
    //   return {
    //     ...state,
    //     loading: false
    //   };
    // }
    // case `${TEMPLATE_NAME}_FULFILLED`: {
    //   // const currentData = state.loadedData;
    //   const newData = action.payload;

    //   return {
    //     ...state,
    //     loading: false,
    //     loadedData: newData,
    //     filter: {
    //       ...state.filter,
    //       data: newData
    //     }
    //   };
    // }
    // case `${TEMPLATE_NAME}_PERPAGE_PENDING`: {
    //   return {
    //     ...state,
    //     loading: true
    //   };
    // }
    // case `${TEMPLATE_NAME}_PERPAGE_FULFILLED`: {
    //   const currentData = state.loadedData;
    //   const newData = action.payload;

    //   return {
    //     ...state,
    //     loading: false,
    //     loadedData: [...currentData, ...newData],
    //     filter: {
    //       ...state.filter,
    //       data: !_.isEmpty(newData) ? newData : currentData
    //     }
    //   };
    // }
    // case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
    //   return {
    //     ...state,
    //     loading: true
    //   };
    // }
    // case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
    //   return {
    //     ...state,
    //     loading: false
    //   };
    // }
    // case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
    //   const { data } = action.payload;
    //   //const currentData = state.loadedData;
    //   return {
    //     ...state,
    //     loading: false,
    //     loadedData: data,
    //     filter: {
    //       ...state.filter,
    //       data: [...data]
    //     }
    //   };
    // }
    case `${TEMPLATE_NAME}_DELETE`: {
      const { id } = action.payload;
      const data = state.loadedData.filter(data => data.id !== id);

      return {
        ...state,
        loading: false,
        loadedData: data,
        filter: {
          ...state.filter,
          data: filterData(data, state.filter.term, state.filter.type)
        }
      };
    }
    case `${TEMPLATE_NAME}_DELETE_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_DELETE_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_DELETE_FULFILLED`: {
      const id = action.payload.id || action.payload;
      const data = state.loadedData.filter(data => data.id !== id);

      return {
        ...state,
        loading: false,
        loadedData: data,
        filter: {
          ...state.filter,
          data: filterData(data, state.filter.term, state.filter.type)
        }
      };
    }
    case `${TEMPLATE_NAME}_REPEATED_DELETE`: {
      const deletedRows = action.payload;
      let data = state.loadedData;

      data = pullAllWith(data, deletedRows, _.isEqual);

      return {
        ...state,
        loading: false,
        loadedData: data,
        filter: {
          ...state.filter,
          data: filterData(data, state.filter.term)
        }
      };
    }
    case `${TEMPLATE_NAME}_CREATE`: {
      const newRow = action.payload;
      //console.log('NEW: ', action.payload);
      const data = [newRow, ...state.loadedData];
      return {
        ...state,
        loading: false,
        loadedData: data,
        filter: {
          ...state.filter,
          data: filterData(data, state.filter.term)
        }
      };
    }
    case `${TEMPLATE_NAME}_REPEATED_CREATE`: {
      const newRows = action.payload;
      const data = [...state.data, ...newRows];
      return {
        ...state,
        loading: false,
        loadedData: data,
        filter: {
          ...state.filter,
          data: filterData(data, state.filter.term)
        }
      };
    }
    case `${TEMPLATE_NAME}_UPDATE`: {
      const updatedRow = action.payload;
      let data;
      if (Array.isArray(updatedRow)) {
        for (let i = 0; i < state.loadedData.length; i++) {
          for (let j = 0; j < updatedRow.length; j++) {
            if (state.loadedData[i].id === updatedRow[j].id) {
              state.loadedData[i] = updatedRow[j];
            }
          }
        }
        data = state.loadedData;
      } else {
        data = state.loadedData.map(row => (row.id === updatedRow.id ? updatedRow : row));
      }
      return {
        ...state,
        loadedData: data,
        filter: {
          ...state.filter,
          data: filterData(data, state.filter.term)
        }
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};
export default reducer;
